<span
  class="badge"
  [ngClass]="getBadgeClass(displayStatus)"
  [ngbPopover]="hierarchy"
  popoverTitle="Approval Status"
>
  {{ displayStatus }}
</span>

<ng-template #hierarchy>
  <ul class="timeline mt-2">
    <li class="timeline-item" *ngFor="let approver of statusList">
      <span
        class="timeline-point timeline-point-indicator"
        [ngClass]="getBadgeClass(approver.status)"
      ></span>

      <div class="timeline-event">
        <div class="d-flex justify-content-between mb-1">
          <div>
            <h6 class="mb-0 font-weight-bolder">{{ approver.approverName }}</h6>
            <small class="text-muted">
              {{ approver.actionDate | date : "dd-MM-yyyy HH:mm" }}
            </small>
          </div>
        </div>

        <div>
          <span class="badge" [ngClass]="getBadgeClass(approver.status)">
            {{ approver.status }}
          </span>

          <span
            *ngIf="approver.remarks"
            class="ml-1"
            [ngbTooltip]="approver.remarks"
          >
            <i data-feather="info"></i>
          </span>
        </div>
      </div>
    </li>
  </ul>
</ng-template>
